import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import { COLORES } from '../../../config/colores'
import EstimacionSemanalStock from '../components/EstimacionSemanalStock'
import { Button, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import SearchIcon from '@material-ui/icons/Search'
import { reduxForm } from 'redux-form'
import { FORM_ESTIMACION_STOCK } from '../../../config/forms'
import { parseEntityId, parseEntityName } from '../../../models/entity'
import { obtenerEstimacionSemanal,
  obtenerEstimacionSemanalExportador,
  actualizarExportadorProyeccion,
  actualizarEstimacionSemanal,
  resetSimulacionPool,
  resetShowDestalleCuposADescargar
} from '../actions/listados'
import UltimaActualizacionData from '../../Utils/containers/UltimaActualizacionDatos'
import EntitySelect from '../../Forms/SharedComponents/containers/EntitySelect'
import InfoIcon from '@material-ui/icons/Info'

function EstimacionSemanalCereal (props) {
  const {
    obtenerEstimacionSemanal,
    actualizarExportadorProyeccion,
    obtenerEstimacionSemanalExportador,
    datosOk,
    simulacion = false,
    exportadorSimulacion = null,
    change: formChange,
    exportadoresActivos
  } = props

  const [busquedaExp, setBusquedaExp] = useState(false)
  const [exportador, setExportador] = useState(exportadorSimulacion || null)
  const [ultimaActualizacion, setUltimaActualizacion] = useState(new Date())

  const handleOnSelected = useCallback((value) => {
    setExportador(value)
    obtenerEstimacionSemanalExportador(parseEntityId(value))
    actualizarExportadorProyeccion(parseEntityId(value), value)
    formChange('exportadorProyeccion', parseEntityId(value))
  }, [formChange, actualizarExportadorProyeccion, obtenerEstimacionSemanalExportador])

  useEffect(() => {
    obtenerEstimacionSemanal()
    setUltimaActualizacion(new Date())
  }, [props.detalleCarga, obtenerEstimacionSemanal])

  useEffect(() => {
    if (exportadorSimulacion) {
      handleOnSelected(exportadorSimulacion)
    }
  }, [exportadorSimulacion, handleOnSelected])

  const actualizar = () => {
    obtenerEstimacionSemanal()
    setUltimaActualizacion(new Date())
  }

  const resetExportador = () => {
    const { change: formChange } = props
    formChange('exportadorProyeccion', '')
    actualizarExportadorProyeccion(null)
    setExportador(null)
    props.actualizarEstimacionSemanal()
  }

  const handleClose = () => {
    setBusquedaExp(false)
    resetExportador()
  }

  const resetSimulacionPool = () => {
    props.resetSimulacionPool()
  }

  const filtrarPorExportador = () => {
    resetExportador()
    setBusquedaExp(true)
    props.resetShowDestalleCuposADescargar()
  }

  return (
    <>
      {simulacion &&
        <Row style={{ marginTop: 0, padding: '8px' }}>
          <Col md={8}>
            <InfoIcon style={{ color: COLORES.grey.dark }} /> Importante: la simulación general no tiene la opción de guardado.
          </Col>
          <Col md={4}>
            <Button
              variant='contained'
              style={{ backgroundColor: COLORES.grey.dark, color: 'white', float: 'right' }}
              onClick={resetSimulacionPool}
            >
                 Restablecer simulación
            </Button>

          </Col>
        </Row>
      }
      { !simulacion && datosOk &&
        <>
          <Row style={{ alignItems: 'center', margin: '1%' }}>
            { !busquedaExp
              ? <>
                <Button
                  variant='outlined'
                  onClick={filtrarPorExportador}
                >
                  <SearchIcon />
                  Buscar exportador
                </Button>

                {exportadoresActivos.map((e) => {
                  return (
                    <Button
                      key={e}
                      variant='outlined'
                      style={{
                        backgroundColor: e === exportador ? COLORES.grey.dark : 'white',
                        color: e === exportador ? 'white' : COLORES.grey.dark,
                        margin: '8px',
                        borderColor: e !== exportador ? COLORES.grey.dark : 'none'
                      }}
                      onClick={() => { handleOnSelected(e) }}
                    >
                      {parseEntityName(e)}
                    </Button>
                  )
                })}

              </>

              : !exportador
                ? <>
                  <Col md={6}>
                    <EntitySelect
                      name={`exportadorProyeccion`}
                      label=' '
                      entity='exportador'
                      placeholder='Seleccione un exportador'
                      value={''}
                      onChange={handleOnSelected}
                      orderBy={'razon_social'}
                      labelKeys={['razonSocial', 'cuit']}
                    />
                  </Col>
                  <IconButton
                    onClick={handleClose}
                    style={{ margin: '0', padding: '5px 0', float: 'right' }}
                  >
                    <CloseIcon style={{ color: COLORES.grey.dark }} />
                  </IconButton>

                </>
                : <>{exportador}</>

            }

            {exportador &&
              <IconButton
                onClick={handleClose}
                style={{ margin: '0', padding: '5px 0', float: 'right' }}
              >
                <CloseIcon style={{ color: COLORES.grey.dark }} />
              </IconButton>
            }
          </Row>
        </>
      }

      <EstimacionSemanalStock simulacion={simulacion} />

      { !props.exportadorProyeccion &&
        <UltimaActualizacionData
          actualizar={actualizar}
          ultimaActualizacion={ultimaActualizacion}
          setUltimaActualizacion={setUltimaActualizacion}
        />
      }
    </>
  )
}

const mapStateToProps = (state) => ({
  datosOk: state.stock.receiveEstimacionExportadores,
  detalleCarga: state.buque.detalleCarga,
  exportadorProyeccion: state.stock.exportadorProyeccion,
  exportadoresActivos: state.stock.exportadoresActivos
})

const mapActionsToProps = {
  actualizarExportadorProyeccion,
  actualizarEstimacionSemanal,
  obtenerEstimacionSemanal,
  obtenerEstimacionSemanalExportador,
  resetSimulacionPool,
  resetShowDestalleCuposADescargar
}

const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(EstimacionSemanalCereal))
